import { styled, Grid } from "@mui/material";

export const Container = styled(Grid)({});
export const CardsContainer = styled(Grid)({
  height: `calc( 94vh - 200px )`,
  overflow: "auto",
});
